import { render, staticRenderFns } from "./transferdetailed.vue?vue&type=template&id=5009e9db"
import script from "./transferdetailed.vue?vue&type=script&lang=js"
export * from "./transferdetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports